<template>
    <div>
        <p-search-screen
            title="Products"
            api-destination="products"
            :filters="filters"
            :filterBy="filterByOptions"
            :fields="fields"
            id-key="sku"
            add-bulk-is-active-toggle
            :use-bootstrap-selection="false"
            :edit-url-func="
                item => `/products/${item.isBook ? 'tx' : 'gm'}/${item.sku}`
            "
        >
            <template v-slot:actionButtons>
                <b-dropdown variant="primary" text="Add">
                    <template v-slot:button-content>
                        <b-icon-plus></b-icon-plus> Add
                    </template>
                    <b-dropdown-item v-b-modal.addBookModal>
                        Add Book
                    </b-dropdown-item>
                    <p-feature-flag name="Common GM">
                        <b-dropdown-item
                            v-b-modal.addCommonGMModal
                            @click="newGmProductType(false, false)"
                        >
                            Add Common GM Product
                        </b-dropdown-item>
                    </p-feature-flag>
                    <p-feature-flag name="Common GM">
                        <b-dropdown-item
                            v-b-modal.addCommonGMModal
                            @click="newGmProductType(true, false)"
                        >
                            Add Matrix GM Product
                        </b-dropdown-item>
                    </p-feature-flag>
                    <b-dropdown-item
                        v-b-modal.addCommonGMModal
                        @click="newGmProductType(false, true)">
                        Add Package Product
                    </b-dropdown-item>
                </b-dropdown>
            </template>
            <template v-slot:appendSlot>
                <div class="append-element">
                    <b-form-radio-group
                        class="rounded-radio-group"
                        v-model="filters.productType"
                        :options="filters.productOptions"
                        button-variant="outline-primary"
                        size="xs"
                        name="radio-btn-outline"
                        buttons
                    ></b-form-radio-group>
                </div>
            </template>
            <template v-slot:addButton>
                <div style="margin-left: 20px;margin-top: 9px">
                    <p-checkbox
                        label="Active"
                        class="ms-3"
                        v-model="filters.active"
                    />
                    <p-checkbox
                        label="Inactive"
                        class="ms-2"
                        v-model="filters.inactive"
                    />
                </div>
            </template>
        </p-search-screen>
        <p-modal
            size="sm"
            name="addBookModal"
            label="Add A New Book"
            hide-footer
            no-close-on-backdrop
        >
            <b-row>
                <b-col>
                    <router-link
                        to="/products/tx/new"
                        class="btn btn-outline-primary"
                        >Add New</router-link
                    >
                </b-col>
                <b-col>
                    <ProductMultiSelectQuickSearch
                        label="Adopt From Buyer's Guide"
                        name="adopt"
                        single-select-button-label="Adopt"
                        search-destination="buyersguidesearch"
                        field-set="buyersGuideFields"
                        default-sort="author"
                        single-select
                        hide-buttons
                        :remove-filter-options="[
                            'SKU',
                            'Description',
                            'Catalog #',
                            'Supplier',
                            'Barcode'
                        ]"
                        :add-filter-options="[
                            'Edition',
                            'Imprint',
                            'Copyright'
                        ]"
                        @selections="adoptSelection"
                    />
                </b-col>
            </b-row>
        </p-modal>
        <p-modal
            size="xl"
            name="addCommonGMModal"
            :label="getAddGmModalTitle()"
            @shown="loadData"
            no-close-on-backdrop
            @hide="(e) => checkDirtyBeforeModalClose(e, 'addCommonGMModal')"
        >
            <template v-slot:default>
                <p-form ref="addGMForm">
                    <p-card title="" v-if="product">
                        <b-row>
                            <p-feature-flag name="Product Images">
                                <b-col cols="12" lg="auto">
                                    <p-image
                                        ref="generalImage"
                                        v-model="
                                            productFamily
                                                .onlineProfileProperties
                                                .images[0]
                                        "
                                        @newURL="newPrimaryURL"
                                    />
                                </b-col>
                            </p-feature-flag>
                            <b-col>
                                <b-row>
                                    <b-col cols="12" lg="8">
                                        <p-input
                                            label="Product Description"
                                            v-model="productFamily.description"
                                            mode="lazy"
                                            rules="required|max:200"
                                        />
                                    </b-col>
                                    <b-col cols="12" lg="4">
                                        <p-select
                                            label="Product Type"
                                            :options="productTypes"
                                            :model-value="determineProductType"
                                            text-field="text"
                                            :disabled="true"
                                            rules="required"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" xl="2" v-if="isPackageGmProduct">
                                        <p-number
                                            label="Cost"
                                            :model-value="calculatePackageCost"
                                            rules="required|min_value:0"
                                            input-type="money"
                                            left-align
                                            disabled="true" />
                                    </b-col>
                                    <b-col cols="12" sm="6" xl="3" v-else>
                                          <p-number
                                            label="Cost"
                                            v-model="productInventory.cost"
                                            rules="required|min_value:0"
                                            input-type="money"
                                            @change="calculateMargin()"
                                            style="max-width: 110px"
                                            left-align>
                                            <template v-slot:append>
                                                <b-button @click="$bvModal.show('addGMProductPriceCalculator')">
                                                    <i class="fas fa-calculator"></i>
                                                </b-button>
                                            </template>
                                        </p-number>
                                    </b-col>
                                    <b-col style="flex: 0 0 115px; max-width: 115px;" class="px-1">
                                        <p-number
                                            label="Margin"
                                            v-model.number="
                                                productInventory.margin
                                            "
                                            rules="required|min_value:0"
                                            disabled="disabled"
                                            input-type="percent"
                                            left-align
                                        >
                                        </p-number>
                                    </b-col>
                                    <b-col cols="12" sm="6" xl="2">
                                        <p-number
                                            label="Selling Price"
                                            v-model="productInventory.sellingPrice"
                                            rules="required|min_value:0"
                                            input-type="money"
                                            @change="calculateMargin()"
                                            left-align>
                                        </p-number>                                                                                
                                    </b-col>                                    
                                    <b-col style="flex: 1 1 0; min-width: 0;">
                                        <p-advanced-select
                                            label="DCC"
                                            data-type="dcc"
                                            @change="dccChanged"
                                            v-model.number="product.dccId"
                                            :filter="dccFilter"
                                            rules="required|min_value:1"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" lg="6">
                                        <p-advanced-select
                                            label="Brand"
                                            data-type="brands"
                                            v-model="
                                                productFamily.productBrandId
                                            "
                                            add-empty-option
                                        >
                                            <template v-slot:append>
                                                <b-button
                                                    class="ms-0 px-1"
                                                    style="white-space:nowrap;"
                                                    v-b-modal.addBrand
                                                    >Add New</b-button
                                                >
                                            </template>
                                        </p-advanced-select>
                                    </b-col>

                                    <b-col cols="12" lg="6">
                                        <p-select
                                            data-type="priceTagTypes"
                                            label="Tag Type"
                                            v-model="product.priceTagTypeId"
                                            :filter="1"
                                        />
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" :lg="!isMatrixGMProduct ? 4 : 12">
                                <p-input
                                    label="Product Notes"
                                    v-model="productFamily.comment"
                                    rules="max:200"
                                />
                            </b-col>

                            <b-col cols="12" lg="4" v-if="!isMatrixGMProduct">
                                <p-advanced-select
                                    label="Size"
                                    name="productDetailSize"
                                    data-type="productVariants"
                                    :filter="'1'"
                                    v-model="product.gmVariant1Id"
                                    add-empty-option
                                >
                                </p-advanced-select>
                            </b-col>
                            <b-col cols="12" lg="4" v-if="!isMatrixGMProduct">
                                <p-advanced-select
                                    label="Color"
                                    name="productDetailColor"
                                    data-type="productVariants"
                                    v-model="product.gmVariant2Id"
                                    :filter="'2'"
                                    add-empty-option
                                >
                                </p-advanced-select>
                            </b-col>
                        </b-row>
                        <b-row v-if="isMatrixGMProduct">
                            <b-col cols="12" lg="6">
                                <p-advanced-select
                                    label="Variant Group 1"
                                    data-type="productVariantGroups"
                                    rules="required"
                                    @input="
                                        getProductVariants(
                                            $event,
                                            'variantgrp1'
                                        )
                                    "
                                    v-model="productFamily.gmVariantGroup1Id"
                                    :filter="filterVariantGroup1"
                                >
                                </p-advanced-select>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <p-advanced-select
                                    label="Variant Group 2"
                                    data-type="productVariantGroups"
                                    add-empty-option
                                    @input="
                                        getProductVariants(
                                            $event,
                                            'variantgrp2'
                                        )
                                    "
                                    v-model="productFamily.gmVariantGroup2Id"
                                    :disabled="!productFamily.gmVariantGroup1Id"
                                     :filter="filterVariantGroup2"
                                >
                                </p-advanced-select>
                            </b-col>
                        </b-row>
                        
                        <b-row v-if="isMatrixGMProduct">
                            <b-col cols="12" lg="6">
                                <p-table
                                    :items="productVariantGroupingsGrp1"
                                    :fields="productVariantFieldsGrp"
                                    :pagination="false"
                                    :showRecordCount="false"
                                    :showEmpty="false"
                                    :per-page="500"
                                    :show-select-all="productVariantGroupingsGrp1.length > 0"
                                    select-all-label="Toggle All"
                                    :is-selected-function="item => item.isActive"
                                    @toggle-selection="item => item.isActive = !item.isActive"
                                >
                                </p-table>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <p-table
                                    :items="productVariantGroupingsGrp2"
                                    :fields="productVariantFieldsGrp"
                                    :pagination="false"
                                    :showRecordCount="false"
                                    :showEmpty="false"
                                    :per-page="500"
                                    :show-select-all="productVariantGroupingsGrp2.length > 0"
                                    select-all-label="Toggle All"
                                    :is-selected-function="item => item.isActive"
                                    @toggle-selection="item => item.isActive = !item.isActive"
                                >
                                </p-table>
                            </b-col>
                        </b-row>
                        <b-row v-if="isPackageGmProduct" class="mt-3">
                            <b-col>
                                <p-form inline>
                                    <ProductMultiSelectQuickSearch
                                        is-active-filter
                                        label="Add Component(s)"
                                        icon-plus
                                        name="newPackageComponentSearch"
                                        @selections="addComponentsToPackage"
                                        search-destination="addcomponenttopackagesearch"
                                        fieldSet="addComponentToPackageFields"
                                        :remove-filter-options="[
                                            'Author',
                                            'Title',
                                            'Catalog #',
                                            'ISBN',                                            
                                            'Supplier',
                                            'Barcode',
                                            'Book Key'
                                        ]"
                                        :per-page="perPageAddComponentToPackage"
                                        @per-page-change="e => { perPageAddComponentToPackage = e }"
                                    />
                                </p-form>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3" v-if="isPackageGmProduct">
                            <b-col cols="12">
                                <h4>Package Components</h4>
                                <p-form inline>
                                    <p-table
                                        :items="newPackageComponents"
                                        :fields="newPackageComponentFields"
                                        :enable-row-selection="false"
                                        ref="packageComponentsToAdd"
                                        :selectable="false"
                                        sort-by="description"
                                        searchDestination="null">
                                            <!-- Add the editable Qty field for adding product(s) to packages -->
                                            <template #cell(qty)="slotData">
                                                <p-input
                                                    v-model="slotData.item.qty"
                                                    size="sm"
                                                    @change="e => { onPackageQtyChange(slotData.item, e); }"
                                                    style="width: 4ch; min-width: 44px;"
                                                    rules="required|integer|min_value:0"
                                                    name="Qty"
                                                    class="text-center" />
                                            </template>                                    
                                            <template #cell(deleteProduct)="slotData">
                                                <b-button class="p-1 ms-1 short-button" @click="deletePackageComponent(slotData.item)">
                                                    <BIconTrash icon="trash"></BIconTrash>
                                                </b-button>
                                            </template>
                                    </p-table>
                                </p-form>
                            </b-col>
                        </b-row>
                    </p-card>
                </p-form>
            </template>
            <template v-slot:modal-footer>
                <b-row>
                    <b-col>
                        <p-button
                            variant="outline-primary"
                            @click="cancelGmModal"
                            class="me-2"
                            :is-busy="generateSKUIsBusy"
                            >Cancel</p-button
                        >
                        <p-button
                            variant="primary"
                            @click="handleGenerateSKU"
                            class="float-end"
                            :is-busy="generateSKUIsBusy"
                            :disabled="isPackageGmProduct && newPackageComponents.length == 0">
                                Generate ({{ isMatrixGMProduct ? calculatedSKUCount : 1 }})
                                SKU{{ calculatedSKUCount > 1 ? 's' : '' }}
                        </p-button>
                    </b-col>
                </b-row>
            </template>
        </p-modal>
        <PriceCalculator
            v-if="parameters"
            name="addGMProductPriceCalculator"
            :initial-values="productInventory"
            :parameters="parameters"
            @apply="applyGMPricing">
        </PriceCalculator>
        <p-modal
            name="addBrand"
            label="Add Brand"
            size="md"
            no-close-on-backdrop
            no-close-esc
            @shown="showModal"
            ref="addBrandModal"
        >
            <template v-slot:default>
                <p-form ref="form">
                    <div>
                        <b-row>
                            <b-col>
                                <p-input
                                    label="Brand Name"
                                    vid="brandName"
                                    v-model="brandName"
                                    rules="required|max:50"
                                    ref="setFocus"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </p-form>
            </template>

            <template v-slot:modal-footer>
                <b-row>
                    <b-col class=" mb-3 text-center">
                        <p-button
                            :is-busy="addingBrandIsBusy"
                            variant="outline-primary"
                            @click="handleAddBrand"
                            >OK</p-button
                        >
                    </b-col>
                </b-row>
            </template>
        </p-modal>
        <p-modal
            size="sm"
            name="addNewUsed"
            label="Create new or new and used?"
            hide-footer
            no-close-on-backdrop
        >
            <div v-if="itemToAdopt">
                <b-row>
                    <b-col>
                        <label>ISBN: </label>
                        <label class="ms-2" style="white-space: nowrap;">{{
                            itemToAdopt.isbn
                        }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Author: </label>
                        <label class="ms-2">{{ itemToAdopt.author }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Title: </label>
                        <label class="ms-2">{{ itemToAdopt.title }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Edition: </label>
                        <label class="ms-2">{{ itemToAdopt.edition }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Binding: </label>
                        <label class="ms-2">{{ itemToAdopt.binding }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Price: </label>
                        <label class="ms-2">{{
                            currencyFormatter(itemToAdopt.retail)
                        }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Imprint: </label>
                        <label class="ms-2">{{ itemToAdopt.imprint }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p-select
                            data-type="suppliers"
                            label="Supplier"
                            v-model="itemToAdopt.supplierId"
                            rules="required"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p-button
                            @click="newOnly"
                            :is-busy="isBusy"
                            variant="outline-primary"
                            >New</p-button
                        >
                    </b-col>
                    <b-col>
                        <p-button
                            @click="newAndUsed"
                            :is-busy="isBusy"
                            variant="outline-primary"
                            >New and Used</p-button
                        >
                    </b-col>
                </b-row>
            </div>
        </p-modal>
    </div>
</template>

<script>
import axios from 'axios';
import {
    currencyFormatter,
    integerFormatter
} from '../../components/Common/Formatters.js';
import ProductMultiSelectQuickSearch from '@/components/ProductMultiSelectQuickSearch.vue';
import PriceCalculator from './PriceCalculator.vue';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import pricing from '@/services/PricingCalculations.js';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import { useSelectListsStore } from '@/stores/selectLists.js';
import { PRODUCT_TYPE_VALUE, PRODUCT_TYPE } from '@/components/Common/Constants.js';

export default {
    mixins: [NavigationGuard, SearchStorage],
    data() {
        return {
            isBusy: false,
            generateSKUIsBusy: false,
            addingBrandIsBusy: false,
            filterName: 'ProductsSearchFilter',
            isMatrixGMProduct: false,
            isPackageGmProduct: false,
            perPageAddComponentToPackage: 10,
            newPackageComponents: [],
            filters: {
                automatic: '',
                perPage: 100,
                sortBy: 'sku',
                sortDesc: true,
                productType: null,
                searchBy: 'All',
                active: true,
                inactive: false,
                productOptions: [
                    { text: 'Books', value: 'Book' },
                    { text: 'GM', value: 'GM' },
                    { text: 'Digital', value: 'Digital' },
                    { text: 'Package', value: 'Package' },
                    { text: 'All', value: null }
                ]
            },
            productVariantGroupingsGrp1: [],
            productVariantGroupingsGrp2: [],
            productVariantFieldsGrp: [
                {
                    key: 'name',
                    label: ''
                }
            ],
            fields: [
                {
                    key: 'author',
                    sortable: true,
                    label: 'Author/Title or Description'
                },
                {
                    key: 'gmVariant1',
                    label: 'Variant 1'
                },
                {
                    key: 'gmVariant2',
                    label: 'Variant 2'
                },
                {
                    key: 'defaultBarcode',
                    sortable: true,
                    label: 'Default Barcode',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'supplierName',
                    sortable: true
                },
                {
                    key: 'sku',
                    sortable: true,
                    label: 'SKU'
                },
                {
                    key: 'productType',
                    sortable: true,
                    label: 'Product Type'
                },                
                {
                    key: 'onOrder',
                    sortable: true,
                    label: 'On Order',
                    thClass: 'text-center',
                    tdClass: 'text-end',
                    formatter: (value) => integerFormatter(value, "-")
                },
                {
                    key: 'sellingPrice',
                    sortable: true,
                    formatter: (value) => currencyFormatter(value, "-"),
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'stockOnHand',
                    sortable: true,
                    label: 'SOH',
                    thClass: 'text-center',
                    tdClass: 'text-end',
                    formatter: (value) => integerFormatter(value, "-")
                },
                {
                    key: 'copyright',
                    sortable: true
                },
                {
                    key: 'edition',
                    sortable: true
                },
                {
                    key: 'isActive',
                    sortable: true,
                    disabled: true
                }
            ],
            newPackageComponentFields: [
                {
                    key: 'qty',
                    label: 'Qty'
                },                
                {
                    key: 'sku',
                    label: 'SKU',
                    sortable: true
                },
                {
                    key: 'authorTitleOrDescription',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'gmVariant1',
                    label: 'Variant 1',
                    tdClass: 'text-center',
                },
                {
                    key: 'gmVariant2',
                    label: 'Variant 2',
                    tdClass: 'text-center',
                },
                {
                    key: 'stockOnHand',
                    label: 'SOH',
                    sortable: true
                },
                {
                    key: 'retail',
                    sortable: true,
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'cost',
                    sortable: true,
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'accountingCost',
                    sortable: true,
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'deleteProduct',
                    label: ''
                }
            ],              
            itemToAdopt: null,
            productFamily: null,
            product: null,
            productInventory: null,
            parameters: null,
            defaultSupplier: '',
            productTypes: [
                { value: PRODUCT_TYPE.COMMON, text: PRODUCT_TYPE.COMMON },
                { value: PRODUCT_TYPE.MATRIX, text: PRODUCT_TYPE.MATRIX },
                { value: PRODUCT_TYPE.PACKAGE, text: PRODUCT_TYPE.PACKAGE }
            ],
            brandName: '',
        };
    },
    methods: {
        getProductVariants(id, groupName) {
            if (id == null) return;
            axios
                .get('productvariantgroup', {
                    params: { id: id }
                })
                .then(resp => {
                    if (resp.data != null) {
                        resp.data.productVariantGroupings = resp.data.productVariantGroupings
                            .filter(x => x.isActive == true)
                            .sort((a, b) => (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER));

                        if (groupName == 'variantgrp1') {
                            this.productVariantGroupingsGrp1 =
                                resp.data.productVariantGroupings;
                        }

                        if (groupName == 'variantgrp2') {
                            this.productVariantGroupingsGrp2 =
                                resp.data.productVariantGroupings;
                        }
                    }
                });
        },
        newGmProductType(isMatrixGmProduct, isPackageGmProduct) {
            this.newPackageComponents = [];
            this.isMatrixGMProduct = isMatrixGmProduct && !isPackageGmProduct;
            this.isPackageGmProduct = isPackageGmProduct && !isMatrixGmProduct;
        },
        cancelGmModal() {
            if (!this.formIsDirty) {
                this.$bvModal.hide('addCommonGMModal');
                return;
            }
            this.$bvModal.msgBoxConfirm([this.displayMessage]).then(value => {
                if (value) {
                    this.dataSaved();
                    this.$bvModal.hide('addCommonGMModal');
                }
            });
        },
        showModal() {
            this.brandName = '';
            this.$refs.setFocus.focus();
        },
        async loadData() {
            this.product = null;
            this.isBusy = true;
            this.productVariantGroupingsGrp1 = [];
            this.productVariantGroupingsGrp2 = [];
            let dataPromise = axios.get('products/generalmerchandise/new');
            let paramPromise = axios.get('products/gmparameters');
            axios.all([dataPromise, paramPromise]).then(
                axios.spread(async (dataResp, paramResp) => {
                    this.parameters = paramResp.data;
                    this.productFamily = dataResp.data;
                    this.product =
                        this.productFamily.products.find(
                            x => x.sku == this.id
                        ) ?? this.productFamily.products[0];
                    this.productInventory =
                        this.product.productInventories.length > 0
                            ? this.product.productInventories[0]
                            : null;
                    this.productFamily.imageUrl = unescape(
                        this.productFamily.onlineProfileProperties.images[0]
                            .dataURL
                    );
                    this.productFamily.packageTypeId = this.parameters.defaultPackageTypeId;
                    this.productFamily.isMatrix = this.isMatrixGMProduct;

                    if(this.isPackageGmProduct)
                        this.productFamily.productType = PRODUCT_TYPE_VALUE.PACKAGE;
                    else if(this.isMatrixGMProduct)
                        this.productFamily.productType = PRODUCT_TYPE_VALUE.MATRIX;

                    this.dataLoaded();
                })
            );
        },
        handleGenerateSKU: async function() {
            if (!(await this.$refs.addGMForm.validate())) 
                return;

            this.productFamily.onlineProfileProperties.shortDescription = this.productFamily.description;
            this.generateSKUIsBusy = true;
            let variantGroup1 = this.productVariantGroupingsGrp1.filter(
                x => x.isActive
            );
            let variantGroup2 = this.productVariantGroupingsGrp2.filter(
                x => x.isActive
            );
            if (variantGroup2.length == 0) {
                for (let i = 0; i < variantGroup1.length; i++) {
                    if (i == 0) {
                        this.productFamily.products[0].gmVariant1Id =
                            variantGroup1[i].productVariantId;
                    } else {
                        this.productFamily.products.push(
                            this.productFamily.products[0]
                        );
                        this.productFamily.products[
                            this.productFamily.products.length - 1
                        ] = {
                            ...this.productFamily.products[
                                this.productFamily.products.length - 1
                            ],
                            gmVariant1Id: variantGroup1[i].productVariantId
                        };
                    }
                }
            } else {
                for (let i = 0; i < variantGroup1.length; i++) {
                    for (let j = 0; j < variantGroup2.length; j++) {
                        if (i == 0 && j == 0) {
                            this.productFamily.products[0].gmVariant1Id =
                                variantGroup1[i].productVariantId;
                            this.productFamily.products[0].gmVariant2Id =
                                variantGroup2[j].productVariantId;
                        } else {
                            this.productFamily.products.push(
                                this.productFamily.products[0]
                            );
                            this.productFamily.products[
                                this.productFamily.products.length - 1
                            ] = {
                                ...this.productFamily.products[
                                    this.productFamily.products.length - 1
                                ],
                                gmVariant1Id: variantGroup1[i].productVariantId,
                                gmVariant2Id: variantGroup2[j].productVariantId
                            };
                        }
                    }
                }
            }

            this.productFamily.productType = this.isPackageGmProduct ? PRODUCT_TYPE_VALUE.PACKAGE : PRODUCT_TYPE_VALUE.COMMON;
            this.productInventory.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            if(this.isPackageGmProduct)
            {
                this.productFamily.packageComponents = this.newPackageComponents
                    .filter(item => Number(item.qty) > 0)
                    .map(item => ({
                        productFamilyId: this.productFamily.productFamilyId,
                        sku: item.sku,
                        qty: Number(item.qty)
                }));
            }

            axios
                .post('products/generalmerchandise', this.productFamily)
                .then(response => {
                    this.$appSuccess(
                            `Product '${this.productFamily.description}' saved successfully.`
                        )
                    this.dataSaved();
                    this.$router.push('/products/gm/' + response.data);
                })
                .finally(() => {
                    this.generateSKUIsBusy = false;
                });
        },
        handleAddBrand(event) {
            if (!this.brandName) {
                event.preventDefault();
                return;
            }

            this.addingBrandIsBusy = true;
            axios
                .post('/brand', {
                    brandName: this.brandName
                })
                .then(resp => {
                    this.$refs.addBrandModal.hide();
                    // Surface the new brand in the dropdown immediately (using the id
                    // the POST returned) so the just-selected value isn't blank until
                    // SignalR refreshes the brands list from the DB.
                    useSelectListsStore().addToList('brands', {
                        value: resp.data,
                        text: this.brandName
                    });
                    this.productFamily.productBrandId = resp.data;
                    this.brandName = '';
                })
                .finally(() => {
                    this.addingBrandIsBusy = false;
                });
        },
        calculateMargin() {
            var cost = this.isPackageGmProduct
                ? this.calculatePackageCost
                : this.productInventory.cost;

            this.productInventory.margin = pricing.computeMargin(
                cost,
                this.productInventory.sellingPrice
            );
        },
        onPackageQtyChange(item, e) {
            let value = e && e.target ? e.target.value : item.qty;
            let qty = parseInt(String(value).replace(/\D/g, ''), 10);
            if (isNaN(qty))  {
                qty = 1;
            }
            else if(qty < 0) {
                qty = 0
            }

            item.qty = qty;

            this.calculateMargin();
        },        
        filterVariantGroup1(variantGroup){
             return variantGroup.value != this.productFamily.gmVariantGroup2Id;
        },
        filterVariantGroup2(variantGroup){
             return variantGroup.value != this.productFamily.gmVariantGroup1Id;
        },
        dccChanged: async function() {
            if (!this.product?.dccId) {
                return;
            }
            axios
                .get('products/dccdefaults', {
                    params: { dccId: this.product.dccId }
                })
                .then(resp => {
                    if (resp.data.margin != null) {
                        this.productInventory.margin = resp.data.margin;
                        this.product.priceTagTypeId = resp.data.priceTagTypeId;
                    }
                });
        },
        dccFilter(dcc) {
            return dcc.filter == 1;
        },
        newPrimaryURL(value) {
            this.productFamily.imageUrl = value;
        },
        currencyFormatter: currencyFormatter,
        adoptSelection: function(item) {
            this.itemToAdopt = item;

            this.$bvModal.show('addNewUsed');
        },
        newOnly() {
            this.adoptItem(true);
        },
        newAndUsed() {
            this.adoptItem(false);
        },
        adoptItem: async function(newOnly) {
            this.isBusy = true;
            this.itemToAdopt.newOnly = newOnly;
            this.itemToAdopt.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            axios
                .post('products/adoptbook', this.itemToAdopt)
                .then(response => {
                    this.$bvModal.hide('addBookModal');
                    this.$bvModal.hide('addNewUsed');
                    this.$router.push('/products/tx/' + response.data);
                    this.$appSuccess(
                            `Product '${this.itemToAdopt.author} / ${this.itemToAdopt.title}' created successfully.`
                        )
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        addComponentsToPackage(items) {
            // Add the qty field to the package products
            const itemsWithQty = items.map(item => ({
                ...item,
                qty: 1
            }));

            this.newPackageComponents = [...this.newPackageComponents, ...itemsWithQty];
        },
        getAddGmModalTitle() {
            if (this.isPackageGmProduct)
                return 'Add New Package GM Product';
            if (this.isMatrixGMProduct)
                return 'Add New Matrix GM Product';
            return 'Add New Common GM Product';
        },
        deletePackageComponent(component) {
            let index = this.newPackageComponents.indexOf(component);
            if (index !== -1) {
                this.newPackageComponents.splice(index, 1);
            }

            this.calculateMargin();
        },
        applyGMPricing(pricing) {
            if (this.productInventory) {
                this.productInventory.cost = pricing.cost;
                this.productInventory.sellingPrice = pricing.retail;
                this.productInventory.margin = pricing.margin;
                this.calculateMargin();
            }
        }      
    },
    computed: {
        calculatedSKUCount: function() {
            return (this.productVariantGroupingsGrp1.filter(x => x.isActive)
                    .length == 0
                    ? 1
                    : this.productVariantGroupingsGrp1.filter(x => x.isActive)
                          .length) *
                (this.productVariantGroupingsGrp2.filter(x => x.isActive)
                    .length == 0
                    ? 1
                    : this.productVariantGroupingsGrp2.filter(x => x.isActive)
                          .length);
        },
        filterByOptions: function() {
            if (this.filters.productType === 'Book') {
                return [
                    'All',
                    'SKU',
                    'Author',
                    'Title',
                    'ISBN',
                    'Barcode',
                    'Supplier'
                ];
            }
            if (this.filters.productType === 'GM') {
                return [
                    'All',
                    'SKU',
                    'Description',
                    'Variant',
                    'Catalog #',
                    'Barcode',
                    'Serial Number',
                    'Supplier'
                ];
            }
            return [
                'All',
                'SKU',
                'Author',
                'Title',
                'Description',
                'Variant',
                'Catalog #',
                'ISBN',
                'Barcode',
                'Serial Number',
                'Supplier',
                'DCC'
            ];
        },
        determineProductType: function() {
            if (this.isPackageGmProduct || this.productFamily?.productType === PRODUCT_TYPE_VALUE.PACKAGE) 
                return PRODUCT_TYPE.PACKAGE;

            return this.isMatrixGMProduct || this.productFamily?.isMatrix ? PRODUCT_TYPE.MATRIX : PRODUCT_TYPE.COMMON;
        },
        calculatePackageCost: function() {
            let totalCost = 0;
            this.newPackageComponents.forEach(product => {
                totalCost += (product.cost || 0) * (product.qty || 0);
            });

            return parseFloat(totalCost.toFixed(2));
        },
        // These expose the constants to the template without having to do "this." everywhere
        PRODUCT_TYPE() { return PRODUCT_TYPE; },
        PRODUCT_TYPE_VALUE() { return PRODUCT_TYPE_VALUE; }
    },
    watch: {
        product: NavigationGuard.$watcher,
        productFamily: NavigationGuard.$watcher,
        newPackageComponents: NavigationGuard.$watcher,
        productVariantGroupingsGrp1: NavigationGuard.$watcher,
        productVariantGroupingsGrp2: NavigationGuard.$watcher
    },
    components: {
        ProductMultiSelectQuickSearch,
        PriceCalculator
    }
};
</script>

<style scoped lang="scss">
:deep(.search-by-select ) {
    /* keep search by select from changing sizes when options change
    due to books/gm/both selection */
    min-width: 135px;
}
:deep(.text-center input ) {
    text-align: center;
}
</style>
